import { logError } from 'client/javascript/util/logger';
import WeGlideWithAutoplay from 'client/javascript/we_glide/we_glide_with_autoplay';

const HERO_SLIDER_SELECTOR = '.home-hero__glide';

export function setupHeroSlider() {
  try {
    const moduleDomNode = document.querySelector(HERO_SLIDER_SELECTOR);
    if (moduleDomNode) {
      const glide = new WeGlideWithAutoplay(HERO_SLIDER_SELECTOR);
      glide.mount();
    }
  } catch (error) {
    logError(`Homepage setupHeroSlider failed: ${error.message}`, error);
  }
}
